<template>
  <button @click="$store.dispatch('logout')">Logout</button>
</template>

<script>
export default {
  name: "LogoutButton",
};
</script>

<style></style>
